import COLORS from "../Helpers/colors";

export enum BuildingType {
    standard = "standard",
    complement = "complement",
    toiletArchipelago = "toilet_archipelago",
    toiletReserve = "toilet_reserve",
    other = "other",
}

/** Every building type in display order. Which ones an instance offers is `global/enabledBuildingTypes`. */
export const ALL_BUILDING_TYPES: readonly BuildingType[] = [
    BuildingType.standard,
    BuildingType.complement,
    BuildingType.toiletArchipelago,
    BuildingType.toiletReserve,
    BuildingType.other,
];

export function iconForBuildingType(type?: BuildingType): string {
    switch (type) {
        case BuildingType.toiletArchipelago:
        case BuildingType.toiletReserve:
            return '/Images/UI/toilet.png';
        case BuildingType.complement:
            return '/Images/UI/building-group.png';
        default:
            return '/Images/UI/building.png';
    }
}

const GROUP_TAG_ICONS: Array<{ prefix: string; icon: string }> = [
    { prefix: 'Byggnadsgrupp', icon: '/Images/UI/building-group.png' },
    { prefix: 'BRF',           icon: '/Images/UI/building-group.png' },
    { prefix: 'green-area',    icon: '/Images/UI/green-area.png' },
    { prefix: 'shelter',       icon: '/Images/UI/shelter.png' },
    { prefix: 'footbridge',    icon: '/Images/UI/footbridge.png' },
    { prefix: 'birdtower',     icon: '/Images/UI/birdtower.png' },
];

export function iconForGroupTag(tag: string): string | undefined {
    return GROUP_TAG_ICONS.find(({ prefix }) => tag.startsWith(prefix))?.icon;
}

export function colorForBuildingType(type?: BuildingType): string {
    switch (type) {
        case BuildingType.standard: default:
            return COLORS.primaryDark;
        case BuildingType.complement:
            return COLORS.deepGreen;
        case  BuildingType.other:
            return COLORS.gold;
    }
}
